<div *ngIf="offerRecommendationsService.recommendationsActive"
     [ngClass]="{'offer-recommendations-section--incomplete-recommendations': !completeRecommendations}"
     class="offer-recommendations-section">
  <div class="offer-recommendations-section__title">
      {{ 'OFFER_RECOMMENDATIONS_SECTION.title' | translate }}
  </div>

  <div class="offer-recommendations-section__tiles">
      <ng-container *ngFor="let recommendation of offerRecommendationsService.activeRecommendations; let i = index">
          <div *ngIf="isRecommendationValid(recommendation); else missingRecommendation"
               class="offer-recommendations-section__tile-container">
            <app-offer-recommendation-tile class="offer-recommendations-section__tile-container__tile"
                                           [recommendation]="recommendation">
            </app-offer-recommendation-tile>
          </div>
          <ng-template #missingRecommendation>
              <div *ngIf="offerRecommendationsService.missingRecommendationTilesEnabled"
                   class="offer-recommendations-section__tile-container">
                  <app-missing-recommendation-tile class="offer-recommendations-section__tile-container__tile"
                                                   [recommendation]="recommendation">
                  </app-missing-recommendation-tile>
              </div>
          </ng-template>
      </ng-container>
  </div>

</div>
